import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d8fb3fa7495700148f9177/barberos/src/app/page.tsx");
